/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
 
const ratePoint = Number('3') < 1  ? 1 :  Number('3');

if($(".shopify-section--main-product").length){
  setRewardPointsDefault();

  // $(document).on('click', '.swatch-option',function() {
  //     setRewardPointsDefault();
  // });
  
  // $(document).on('click', '.super-attribute-select',function() {
  //     setRewardPointsDefault();
  // });
  
  $('.product-form .product-form__quantity .quantity-selector__input').change( function() {
      setRewardPointsDefault();
  });

  $(document).on('click','.quantity-selector__button', function() {
    setRewardPointsDefault();
  });

  $(document).on('click','.block-swatch input', function() {
    setRewardPointsDefault();
  });
  $(document).on('change','.block-swatch input', function() {
    setRewardPointsDefault();
  });

  
  
  
  function setRewardPointsDefault() {
      console.log('CALLED setRewardPointsDefault');
      var checkExist = setInterval(function() {
          if ($("[data-product-price-list] .price.price--highlight").length) {
              var priceFormat = $("[data-product-price-list] .price.price--highlight").text();
              var priceNumber = Number(priceFormat.replace(/[^0-9.-]+/g,""));
              let qty = +($(".product-form .product-form__quantity .quantity-selector__input").val());
              $("#ratePoints").text(Math.floor(priceNumber) * ratePoint * qty);
              clearInterval(checkExist);
          }
      }, 200); // check every 200ms
  }
  // $(window).load(function () { setRewardPointsDefault(); });

  
}

$(function(){

setInterval(function time(){
  var d = new Date();
  var hours = 23 - d.getHours();
  var min = 60 - d.getMinutes();
  if((min + '').length == 1){
    min = '0' + min;
  }
  var sec = 60 - d.getSeconds();
  if((sec + '').length == 1){
        sec = '0' + sec;
  }
  jQuery('#the-24h-countdown p').html('<span><time>'+hours+'</time><small>Hours</small></span><span class="min"><time>'+min+'</time><small>Minutes</small></span><span class="seg"><time>'+sec+'</time><small>Seconds</small></span>');
  jQuery('.the-24h-countdown p').html('<span><time> '+hours+'</time><small>h </small></span><span class="min"><time>'+min+'</time><small>m </small></span><span class="seg"><time>'+sec+'</time><small>s</small></span>');
}, 1000);
  
  $(document).on('click', "#smile-rewards", function(){
    $('#smile-ui-container').css('visibility','visible');
    $('#smile-ui-container').css('opacity','1');
  });
  
  $(document).on('click', "#before-submit", function(event){
    
    event.preventDefault();
    
    this.setAttribute("aria-busy", "true");
    let input_values =  $("#customer_login").serializeArray();
    let customerEmail = '';
    $.each(input_values, function(k, v){
        if(v.name == 'customer[email]'){
          customerEmail = v.value;
        }
    });

    var postData={"email": customerEmail}; 

    fetch('https://customer.dealgenius.workers.dev/', {
        method: 'POST',
        mode: 'cors',
        headers: {  
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
    })      
    .then(response => response.json())
    .then(result => { 
        console.log(result);
        if(result.state == 'disabled'  ){
          window.location = result.results.account_activation_url;
        }else{
          $("#customer_login").submit();
        }
    }); 
  });

  let $t = setInterval(() => {
    if($("#bonus-deals").length){
      clearInterval($t);
      $.get('https://www.dealgenius.com/apps/todays-deals', function(data){

        let $bonusDealsHtml = $(data).find('.daily_deals__container--grid');

        $("#bonus-deals").html($bonusDealsHtml);
        console.log($(data).find("#myModal").length)
        $('body').append('<div><div class="modal-card" id="myModal"><div class="modal-box"><div class="moda-header"><h4><span id="popup-quantity"></span> Product added to your cart.</h4><button onclick="closeDesktopModal();" class="daily_deals__close"><img src="https://assets.dailydeals.ai/images/close.svg" alt="Close Modal"></button></div><div class="modal-content-dd"><div class="product__modal__img"><img id="popupProductImage"></div><div class="modal-body"><span id="popupProductTitle" class="title__products"></span><span id="popupProductVariant"></span><div class="view__counter"></div><div class="daily_deals__price" style="display:none !important"><div class="daily_deals__offers"><p class="daily_deals__reg"><span id="popupProductPriceOriginal" style="text-decoration: line-through;"></span></p></div><h2 id="popupProductPriceDeal"></h2></div><div style="flex-direction: row;" class="daily_deals__btn-holder"><button onclick="viewCart();" class="daily_deals__cta daily_deals__cta-primary" style="width: 45%; margin-right: 8px; border: 1px solid #F2AE00; color: #F2AE00; background: none; opacity: 0.9;">View Cart</button><button onclick="continueToCheckout();" class="daily_deals__cta daily_deals__cta-primary" style="background: #F2AE00; width: 55%; margin-left: 8px;">Continue To Checkout</button></div></div></div></div></div></div>');

      });
    }
  }, 100);


  $(document).on('click', '.variant-swatch__item', function(e){
    let id = $(this).attr("for");
    let $image = $("#"+id).attr('src') || $("#"+id).attr('data-image') || null;
    console.log($image);
    console.log(id);
    if($image){
      $(this).closest('.product-item').find('.product-item__primary-image').attr('srcset','');
      $(this).closest('.product-item').find('.product-item__primary-image').attr('src',$image);
    }
  });
  
  /*$(document).on('change', '.variant-swatch__radio', function(e){
    e.preventDefault();
    
    if($(this).attr('data-image')){
      console.log($(this).attr('data-image'));
      console.log($(this).val());
      $(this).closest('.product-item').find('.product-item__primary-image').attr('srcset','')
      $(this).closest('.product-item').find('.product-item__primary-image').attr('src',$(this).attr('data-image') )
    }
  });*/

})


const mediaQuery = '(min-width: 1000px)';
const mediaQueryList = window.matchMedia(mediaQuery);

if (mediaQueryList.matches) {
  //desktop
  $('.block-content').appendTo('.desktop-block-content');
} else {
  //mobile
  $('.block-content').appendTo('.mobile-block-content');
}

mediaQueryList.addEventListener('change', event => {
  if (event.matches) {
    //mobile
    $('.mobile-block-content .block-content').appendTo('.desktop-block-content');  
  } else {
    //desktop
    $('.desktop-block-content .block-content').appendTo('.mobile-block-content');  
    
  }
})

